import React, { useContext, useCallback } from 'react'
import context from '@/context'
import { Col, Row } from 'reactstrap'
import { FormRow } from '@/components/changeRequests'
import { InfoContent, InfoRow } from '@/components/InfoRow'
import Resx from '@/components/Resx'
import { usePropertyReader } from '@/hooks/usePropertyReader'
import { FormContext } from '@/components/changeRequests/formContext'
import { ChangeItemFileAttachments } from '@/components/changeRequests/fileAttachments'
import { individualPermissionTypes } from '@/enums/individualPermissionTypes'
import { IndividualPermissionProvider } from '../changeRequests/individualPermissionProvider'

const IndividualGovernmentService = React.memo(function InstitutionGovernmentService (props) {
  return <IndividualPermissionProvider individualPermission={individualPermissionTypes.enum.IndividualGovernmentService}>
    <GovernmentService {...props} />
  </IndividualPermissionProvider>
})

const GovernmentService = React.memo(function GovernmentService (props) {
  const [hasGovernmentService] = usePropertyReader(['hasGovernmentService'])
  const { mode } = useContext(FormContext)
  const getAttachmentsTableData = useCallback((req) => context.api.individualService.getGovernmentServiceAttachmentsTableData(props.id, req), [props.id])
  const hideWhenUnchecked = (hasGovernmentService ? {} : { style: { display: 'none' } })

  if (mode === 'view' && !hasGovernmentService) {
    return (
      <InfoRow>
        <InfoContent><Resx name='Individuals.NoGovernmentServiceHistory' /></InfoContent>
      </InfoRow>
    )
  }
  return (
    <IndividualPermissionProvider individualPermission={individualPermissionTypes.enum.IndividualGovernmentService}>
      <Row>
        <Col lg='6'>
          <FormRow label='Individuals.GovernmentServiceHistory' name='hasGovernmentService' inputType='checkbox' />
          <div {...hideWhenUnchecked}>
            <FormRow
              label='Individuals.Directorate'
              name='governmentServiceDirectorate'
              required={hasGovernmentService}
              readonly={!hasGovernmentService}
              inputProps={{ maxLength: 64 }}
            />
            <FormRow label='Individuals.Years' name='governmentServiceYears' inputType='number' required={hasGovernmentService} readonly={!hasGovernmentService} />
          </div>
        </Col>
      </Row>
      <Row {...hideWhenUnchecked}>
        <Col lg='12'>
          <FormRow label='Common.Description' name='governmentServiceDescription' inputType='textarea' readonly={!hasGovernmentService} preText />
          <FormRow label='Individuals.Testimonial' name='governmentServiceTestimonial' inputType='textarea' readonly={!hasGovernmentService} />
          <FormRow label='Individuals.Note' name='governmentServiceNote' inputType='textarea' readonly={!hasGovernmentService} />
        </Col>
      </Row>
      <Row {...hideWhenUnchecked}>
        <Col lg='12'>
          <ChangeItemFileAttachments
            target={props.target}
            name='governmentServiceAttachments'
            dataSource={getAttachmentsTableData}
            downloadAction={context.api.individualService.downloadGovernmentServiceAttachment}
            simpleView
            attachmentsView />
        </Col>
      </Row>
    </IndividualPermissionProvider>
  )
})

export { IndividualGovernmentService }



// WEBPACK FOOTER //
// ./src/components/demographics/governmentService.js